/* tslint:disable */
/* eslint-disable */
export enum Units {
  English = 0,
  Metric = 1
}
